/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
(function () {
  function initComparison(section) {
    var headerRow = section.querySelector('.desk_product-comparison__row--header');
    if (!headerRow) return;

    var cells = headerRow.querySelectorAll('.desk_product-comparison__cell--header');

    cells.forEach(function (cell, cellIndex) {
      var mainImg = cell.querySelector('.desk_product-comparison__image');
      var productLink = cell.querySelector('.desk_product-comparison__product-link');
      var imageWrap = cell.querySelector('.desk_product-comparison__image-wrap');
      var moreLink = cell.querySelector('.desk_product-comparison__variants-more');
      var hoverSrc = mainImg ? mainImg.dataset.hoverSrc : null;

      function getStickyCell() {
        return section.querySelectorAll('.desk_product-comparison__sticky-cell')[cellIndex] || null;
      }

      function updateLinks(variantId) {
        var base;
        if (productLink) {
          base = productLink.getAttribute('href').split('?')[0];
          productLink.setAttribute('href', variantId ? base + '?variant=' + variantId : base);
        }
        if (imageWrap) {
          base = imageWrap.getAttribute('href').split('?')[0];
          imageWrap.setAttribute('href', variantId ? base + '?variant=' + variantId : base);
        }
        if (moreLink) {
          base = moreLink.getAttribute('href').split('?')[0];
          moreLink.setAttribute('href', variantId ? base + '?variant=' + variantId : base);
        }
      }

      function setMainImage(src) {
        if (!src || !mainImg) return;
        mainImg.src = src;
        mainImg.srcset = '';
        var stickyCell = getStickyCell();
        if (stickyCell) {
          var stickyImg = stickyCell.querySelector('img');
          if (stickyImg) {
            stickyImg.src = src;
            stickyImg.srcset = '';
          }
        }
      }

      function applyVariant(input) {
        if (!input) return;
        var src = input.dataset.image;
        setMainImage(src);
        updateLinks(input.dataset.variantId);
        var name = input.getAttribute('name');
        if (name) {
          cell.querySelectorAll('input[name="' + name + '"]').forEach(function (el) {
            el.checked = false;
          });
        }
        input.checked = true;
      }

      function applyType(typeInput) {
        if (!typeInput) return;
        var typeName = typeInput.dataset.name;

        cell.querySelectorAll('.desk_product-comparison__variant--color').forEach(function (el) {
          el.style.display = el.dataset.name === typeName ? '' : 'none';
        });

        var firstChecked = cell.querySelector('.desk_product-comparison__variant--color[data-name="' + typeName + '"] input.variant-input:checked');
        if (!firstChecked) {
          firstChecked = cell.querySelector('.desk_product-comparison__variant--color[data-name="' + typeName + '"] input.variant-input');
        }
        if (firstChecked) applyVariant(firstChecked);

        typeInput.checked = true;
      }

      cell.querySelectorAll('.desk_product-comparison__variant--color .variant__label').forEach(function (label) {
        var input = cell.querySelector('input[id="' + label.getAttribute('for') + '"]');
        label.addEventListener('mouseenter', function () { applyVariant(input); });
        label.addEventListener('click', function () { applyVariant(input); });
      });

      cell.querySelectorAll('.desk_product-comparison__variant--type .type__label').forEach(function (label) {
        var input = cell.querySelector('input[id="' + label.getAttribute('for') + '"]');
        label.addEventListener('mouseenter', function () { applyType(input); });
        label.addEventListener('click', function () { applyType(input); });
      });

      if (hoverSrc) {
        var variantsWrap = cell.querySelector('.desk_product-comparison__variants');
        if (variantsWrap) {
          variantsWrap.addEventListener('mouseleave', function () { setMainImage(hoverSrc); });
        }

        if (imageWrap) {
          imageWrap.addEventListener('mouseenter', function () {
            var checked = cell.querySelector('.variant-input:checked');
            if (checked && checked.dataset.image) {
              setMainImage(checked.dataset.image);
            } else if (mainImg && mainImg.dataset.variantSrc) {
              setMainImage(mainImg.dataset.variantSrc);
            }
          });
          imageWrap.addEventListener('mouseleave', function () { setMainImage(hoverSrc); });
        }
      }
    });
  }

  function initStickyBar(section) {
    if ($(window).width() > 799) return;

    var sticky = section.querySelector('.desk_product-comparison__sticky');
    if (!sticky) return;

    var headerRow = section.querySelector('.desk_product-comparison__row--header');
    if (!headerRow) return;

    var siteHeader = document.querySelector('header');
    var columnsWrap = section.querySelector('.desk_product-comparison__columns-wrap');
    var stickyRow = sticky.querySelector('.desk_product-comparison__sticky-row');
    var collectionBar = document.querySelector('.collection-bar');

    function getSiteHeaderHeight() {
      var headerBottom = 0;
      if (siteHeader) {
        var headerRect = siteHeader.getBoundingClientRect();
        if (headerRect.bottom > 0) {
          headerBottom = headerRect.bottom;
        }
      }

      var collectionBarBottom = 0;
      var activeCollectionBar = document.querySelector('.collection-bar');
      if (activeCollectionBar) {
        var barRect = activeCollectionBar.getBoundingClientRect();
        if (barRect.height > 0 && barRect.bottom > 0) {
          collectionBarBottom = barRect.bottom;
        }
      }
      return Math.max(headerBottom, collectionBarBottom);
    }

    function syncStickyCellWidths() {
      var mainCells = columnsWrap
        ? columnsWrap.querySelectorAll('.desk_product-comparison__row--header .desk_product-comparison__cell--header')
        : [];
      var stickyCells = stickyRow
        ? stickyRow.querySelectorAll('.desk_product-comparison__sticky-cell')
        : [];

      mainCells.forEach(function (cell, i) {
        if (stickyCells[i]) {
          var w = cell.getBoundingClientRect().width;
          stickyCells[i].style.flex = '0 0 ' + w + 'px';
          stickyCells[i].style.maxWidth = w + 'px';
        }
      });
    }

    syncStickyCellWidths();

    var columnsResizeObserver = new ResizeObserver(syncStickyCellWidths);
    if (columnsWrap) columnsResizeObserver.observe(columnsWrap);

    if (columnsWrap && stickyRow) {
      columnsWrap.addEventListener('scroll', function () {
        stickyRow.scrollLeft = columnsWrap.scrollLeft;
      });
      stickyRow.addEventListener('scroll', function () {
        columnsWrap.scrollLeft = stickyRow.scrollLeft;
      });
    }

    function updateStickyVisibility(headerRowGone, sectionVisible) {
      if (headerRowGone && sectionVisible) {
        sticky.style.transform = 'translateY(0)';
        sticky.style.opacity = '1';
        sticky.style.pointerEvents = 'all';
      } else {
        sticky.style.transform = 'translateY(-100%)';
        sticky.style.opacity = '0';
        sticky.style.pointerEvents = 'none';
      }
    }
    var ticking = false;

    function update() {
      ticking = false;

      var headerHeight = getSiteHeaderHeight();
      sticky.style.top = headerHeight + 'px';

      var headerRowGone = headerRow.getBoundingClientRect().bottom <= headerHeight;

      var stickyHeight = sticky.getBoundingClientRect().height;
      var sectionRect = section.getBoundingClientRect();
      var sectionVisible = sectionRect.top < (window.innerHeight - stickyHeight) && sectionRect.bottom > headerHeight;

      updateStickyVisibility(headerRowGone, sectionVisible);
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }

    update();

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    if (siteHeader) new ResizeObserver(requestUpdate).observe(siteHeader);
    new ResizeObserver(requestUpdate).observe(sticky);

    if (collectionBar) {
      new MutationObserver(requestUpdate).observe(collectionBar, { attributes: true });
      collectionBar.addEventListener('transitionend', requestUpdate);
    }

    new MutationObserver(requestUpdate).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  document.querySelectorAll('.desk_product-comparison').forEach(function (section) {
    initComparison(section);
    initStickyBar(section);
  });
})();

$(function () {
  if (typeof ScrollReveal === 'undefined') return;
  if ($(window).width() <= 800) return;

  var sr = ScrollReveal();

  sr.reveal('.desk_product-comparison__title', {
    origin: 'bottom',
    distance: '20px',
    duration: 700,
    delay: 0,
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    opacity: 0,
    scale: 1,
    once: true
  });

  sr.reveal('.desk_product-comparison__text', {
    origin: 'bottom',
    distance: '20px',
    duration: 700,
    delay: 0,
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    opacity: 0,
    scale: 1,
    once: true
  });

  sr.reveal('.desk_product-comparison__content', {
    origin: 'bottom',
    distance: '20px',
    duration: 700,
    delay: 0,
    easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    opacity: 0,
    scale: 1,
    interval: 40,
    once: true
  });
});